import { render, staticRenderFns } from "./flightDetails.vue?vue&type=template&id=01132218&scoped=true"
import script from "./flightDetails.vue?vue&type=script&lang=js"
export * from "./flightDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01132218",
  null
  
)

export default component.exports